export default __webpack_public_path__ + "static/media/ws.65adaddd.jpg";